var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWifi = function SvgWifi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9 21a2 2 0 110-4 2 2 0 010 4zm4.923-6.975a1 1 0 01-1.406 1.421A4.971 4.971 0 0011.9 14a4.971 4.971 0 00-3.518 1.446 1 1 0 01-1.406-1.421A6.972 6.972 0 0111.9 12a6.971 6.971 0 014.923 2.025zm5.683-5.632a1 1 0 01-1.414 1.415A12.958 12.958 0 0011.9 6C8.403 6 5.13 7.385 2.707 9.808a1 1 0 01-1.414-1.415A14.953 14.953 0 0111.9 4a14.957 14.957 0 0110.606 4.393zm-2.869 2.788a1 1 0 11-1.407 1.422A8.953 8.953 0 0011.9 10a8.953 8.953 0 00-6.331 2.603 1 1 0 01-1.407-1.421A10.952 10.952 0 0111.9 8a10.952 10.952 0 017.737 3.18z"
  })));
};
export default SvgWifi;